<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Amino Acid Table</div>
    <div class="aa-table"></div>
</div>